export class TagApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getTags(params) {
    return this.#http.get('/Tag', { params });
  }

  async editTag({ tagId, ...body }) {
    return this.#http.put(`/Tag/${tagId}`, body);
  }

  async createTag(body) {
    return this.#http.post(`/Tag`, body);
  }

  async deleteTag({ tagId }) {
    return this.#http.delete(`/Tag/${tagId}`);
  }
}
